<p style="text-align: center;">Reports are currently not implemented.</p>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/reports/report-listing/report-listing.component.html